import { ComposableMap, Geographies, Geography } from "react-simple-maps";

const GEO_URL = "https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json";

export const WorldMapWidget = ({ data, loading }) => {
  const countries = data?.top_countries || [];
  const lookup = {};
  let max = 1;
  countries.forEach((c) => {
    lookup[c.country] = c.count;
    if (c.count > max) max = c.count;
  });

  const colorFor = (name) => {
    const count = lookup[name];
    if (!count) return "#1E293B";
    const intensity = Math.min(1, count / max);
    const r = Math.round(30 + intensity * (245 - 30));
    const g = Math.round(41 + intensity * (158 - 41));
    const b = Math.round(59 + intensity * (11 - 59));
    return `rgb(${r},${g},${b})`;
  };

  return (
    <div data-testid="world-map-widget" className="bg-slate-900/80 border border-slate-800 rounded-xl p-5 shadow-lg backdrop-blur-md">
      <h3 className="text-lg font-semibold text-slate-200 mb-4" style={{ fontFamily: "'Outfit', sans-serif" }}>Global Listener Map</h3>
      {loading ? (
        <p className="text-sm text-slate-500">Loading…</p>
      ) : countries.length === 0 ? (
        <p className="text-sm text-slate-500">No consented geo data yet.</p>
      ) : (
        <div className="flex flex-col lg:flex-row gap-6">
          <div className="flex-1" style={{ minHeight: 260 }}>
            <ComposableMap projectionConfig={{ scale: 130 }} width={800} height={260} style={{ width: "100%", height: "auto" }}>
              <Geographies geography={GEO_URL}>
                {({ geographies }) =>
                  geographies.map((geo) => (
                    <Geography
                      key={geo.rsmKey}
                      geography={geo}
                      fill={colorFor(geo.properties.name)}
                      stroke="#0D1322"
                      strokeWidth={0.5}
                      style={{
                        default: { outline: "none" },
                        hover: { outline: "none", fill: "#F59E0B" },
                        pressed: { outline: "none" },
                      }}
                    />
                  ))
                }
              </Geographies>
            </ComposableMap>
          </div>
          <div className="lg:w-56 space-y-3 shrink-0">
            <div>
              <p className="text-[10px] uppercase tracking-wider text-slate-500 font-mono mb-1.5">Top Countries</p>
              <div className="space-y-1.5">
                {countries.slice(0, 6).map((c) => (
                  <div key={c.country} className="flex items-center justify-between text-xs">
                    <span className="text-slate-300 truncate">{c.country}</span>
                    <span className="text-slate-500 font-mono">{c.count}</span>
                  </div>
                ))}
              </div>
            </div>
            {(data?.top_cities || []).length > 0 && (
              <div>
                <p className="text-[10px] uppercase tracking-wider text-slate-500 font-mono mb-1.5">Top Cities</p>
                <div className="space-y-1.5">
                  {data.top_cities.slice(0, 6).map((c) => (
                    <div key={c.city} className="flex items-center justify-between text-xs">
                      <span className="text-slate-300 truncate">{c.city}</span>
                      <span className="text-slate-500 font-mono">{c.count}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
